import { Record, Map } from "immutable"

const DawgHistory = Record({
  id: 0,
  dawg: Map(),
  previous_history: Map()
})

export default DawgHistory
